import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  suggestions: {
    fontSize: 'var(--font-size-md)',
    color: 'var(--text-color-main)',
    fontWeight: 'var(--font-weight-light)',
    lineHeight: 1.6,
    margin: '12px 0'
  },
  suggestionLink: {
    color: 'var(--color-primary-500)',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: 'var(--color-primary-600)'
    }
  }
}))

function InlineSuggestions ({ content, onSuggestionClick }) {
  const classes = useStyles()

  // Parse the YAML-like format to extract labels and prompts
  const parseSuggestions = (text) => {
    const suggestions = []
    const blocks = text.split(/- label:/).filter(block => block.trim())

    for (const block of blocks) {
      const lines = block.split('\n').map(line => line.trim()).filter(line => line)
      if (lines.length === 0) continue

      const label = lines[0]
      const promptLine = lines.find(line => line.startsWith('prompt:')) || lines[1]
      const prompt = promptLine?.replace(/^prompt:\s*/, '').trim()

      if (label && prompt) {
        suggestions.push({ label, prompt })
      }
    }

    return suggestions
  }

  const suggestions = parseSuggestions(content || '')

  if (suggestions.length === 0) {
    return null
  }

  const handleClick = (prompt) => {
    if (onSuggestionClick) {
      onSuggestionClick(prompt)
    }
  }

  // Format the text with links
  const formatText = () => {
    if (suggestions.length === 1) {
      return (
        <>
          Would you like to{' '}
          <span
            className={classes.suggestionLink}
            onClick={() => handleClick(suggestions[0].prompt)}
          >
            {suggestions[0].label}
          </span>
          ?
        </>
      )
    }

    const links = suggestions.map((suggestion, index) => (
      <React.Fragment key={index}>
        <span
          className={classes.suggestionLink}
          onClick={() => handleClick(suggestion.prompt)}
        >
          {suggestion.label}
        </span>
        {index < suggestions.length - 2 && ', '}
        {index === suggestions.length - 2 && ', or '}
      </React.Fragment>
    ))

    return <>Would you like to {links}?</>
  }

  return (
    <div className={classes.suggestions}>
      {formatText()}
    </div>
  )
}

InlineSuggestions.propTypes = {
  content: PropTypes.string.isRequired,
  onSuggestionClick: PropTypes.func
}

export default InlineSuggestions
